import styled from 'styled-components';

export default styled.h3`
  text-align: center;
  font-weight: 500;
`;
